import { jsx } from '@emotion/react';
import { clsx } from 'clsx';
import { useEffect } from 'react';
import { ListBoxItem } from 'react-aria-components';
import { Icon } from '@zapier/design-system';
import { useSelectContext } from './SelectContext.es.js';

const selectItem = "_select-item_1g2zo_1";
const styles = {
	selectItem: selectItem
};

const SelectItem = ({ children, className, isDisabled = false, iconName, size, textValue, value }) => {
  const { registerDisabledItem } = useSelectContext();
  useEffect(() => {
    if (isDisabled) {
      registerDisabledItem(value || "");
    }
  }, [isDisabled, value, registerDisabledItem]);
  return jsx(
    ListBoxItem,
    { className: clsx(className, styles.selectItem), "data-size": size, "data-zds": true, id: value, textValue },
    iconName && jsx(Icon, { name: iconName, size: 16 }),
    children
  );
};

export { SelectItem };
//# sourceMappingURL=SelectItem.es.js.map
